/**
 * Generated by orval v8.12.1 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { customFetch } from "../custom-fetch";
import type {
	GetRecentSessionData400,
	GetRecentSessionData500,
	LoadSessionData200,
	LoadSessionData400,
	LoadSessionData403,
	LoadSessionData500,
	LoadSessionDataParams,
	PollForUpdates200,
	PollForUpdates400,
	PollForUpdates401,
	PollForUpdates500,
	PollForUpdatesBody,
	RecentDataItem,
} from "./schemas";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getGetRecentSessionDataUrl = () => {
	return `/session/recent-data`;
};

/**
 * @summary Get the most recent sensor data for the current user's devices
 */
export const getRecentSessionData = async (
	options?: RequestInit,
): Promise<RecentDataItem[]> => {
	return customFetch<RecentDataItem[]>(getGetRecentSessionDataUrl(), {
		...options,
		method: "GET",
	});
};

export const getGetRecentSessionDataQueryKey = () => {
	return ["session", "recent-data"] as const;
};

export const getGetRecentSessionDataQueryOptions = <
	TData = Awaited<ReturnType<typeof getRecentSessionData>>,
	TError = GetRecentSessionData400 | GetRecentSessionData500,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getRecentSessionData>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customFetch>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetRecentSessionDataQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getRecentSessionData>>
	> = ({ signal }) => getRecentSessionData({ signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getRecentSessionData>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRecentSessionDataQueryResult = NonNullable<
	Awaited<ReturnType<typeof getRecentSessionData>>
>;
export type GetRecentSessionDataQueryError =
	| GetRecentSessionData400
	| GetRecentSessionData500;

export function useGetRecentSessionData<
	TData = Awaited<ReturnType<typeof getRecentSessionData>>,
	TError = GetRecentSessionData400 | GetRecentSessionData500,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getRecentSessionData>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getRecentSessionData>>,
					TError,
					Awaited<ReturnType<typeof getRecentSessionData>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRecentSessionData<
	TData = Awaited<ReturnType<typeof getRecentSessionData>>,
	TError = GetRecentSessionData400 | GetRecentSessionData500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getRecentSessionData>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getRecentSessionData>>,
					TError,
					Awaited<ReturnType<typeof getRecentSessionData>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRecentSessionData<
	TData = Awaited<ReturnType<typeof getRecentSessionData>>,
	TError = GetRecentSessionData400 | GetRecentSessionData500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getRecentSessionData>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the most recent sensor data for the current user's devices
 */

export function useGetRecentSessionData<
	TData = Awaited<ReturnType<typeof getRecentSessionData>>,
	TError = GetRecentSessionData400 | GetRecentSessionData500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getRecentSessionData>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetRecentSessionDataQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get the most recent sensor data for the current user's devices
 */
export const useSetGetRecentSessionDataQueryData = () => {
	const queryClient = useQueryClient();
	return (
		updater:
			| Awaited<ReturnType<typeof getRecentSessionData>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getRecentSessionData>> | undefined,
			  ) => Awaited<ReturnType<typeof getRecentSessionData>> | undefined),
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof getRecentSessionData>>
		>({ queryKey: getGetRecentSessionDataQueryKey() }, updater);
	};
};

/**
 * @summary Get the most recent sensor data for the current user's devices
 */
export const useGetGetRecentSessionDataQueryData = () => {
	const queryClient = useQueryClient();
	return () =>
		queryClient.getQueryData<Awaited<ReturnType<typeof getRecentSessionData>>>(
			getGetRecentSessionDataQueryKey(),
		);
};

export const getLoadSessionDataUrl = (params?: LoadSessionDataParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/session/data?${stringifiedParams}`
		: `/session/data`;
};

/**
 * @summary Load full session data for the current user (admin can target a specific userId)
 */
export const loadSessionData = async (
	params?: LoadSessionDataParams,
	options?: RequestInit,
): Promise<LoadSessionData200> => {
	return customFetch<LoadSessionData200>(getLoadSessionDataUrl(params), {
		...options,
		method: "GET",
	});
};

export const getLoadSessionDataQueryKey = (params?: LoadSessionDataParams) => {
	return ["session", "data", ...(params ? [params] : [])] as const;
};

export const getLoadSessionDataQueryOptions = <
	TData = Awaited<ReturnType<typeof loadSessionData>>,
	TError = LoadSessionData400 | LoadSessionData403 | LoadSessionData500,
>(
	params?: LoadSessionDataParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof loadSessionData>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getLoadSessionDataQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof loadSessionData>>> = ({
		signal,
	}) => loadSessionData(params, { signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof loadSessionData>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LoadSessionDataQueryResult = NonNullable<
	Awaited<ReturnType<typeof loadSessionData>>
>;
export type LoadSessionDataQueryError =
	| LoadSessionData400
	| LoadSessionData403
	| LoadSessionData500;

export function useLoadSessionData<
	TData = Awaited<ReturnType<typeof loadSessionData>>,
	TError = LoadSessionData400 | LoadSessionData403 | LoadSessionData500,
>(
	params: undefined | LoadSessionDataParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof loadSessionData>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof loadSessionData>>,
					TError,
					Awaited<ReturnType<typeof loadSessionData>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLoadSessionData<
	TData = Awaited<ReturnType<typeof loadSessionData>>,
	TError = LoadSessionData400 | LoadSessionData403 | LoadSessionData500,
>(
	params?: LoadSessionDataParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof loadSessionData>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof loadSessionData>>,
					TError,
					Awaited<ReturnType<typeof loadSessionData>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLoadSessionData<
	TData = Awaited<ReturnType<typeof loadSessionData>>,
	TError = LoadSessionData400 | LoadSessionData403 | LoadSessionData500,
>(
	params?: LoadSessionDataParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof loadSessionData>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Load full session data for the current user (admin can target a specific userId)
 */

export function useLoadSessionData<
	TData = Awaited<ReturnType<typeof loadSessionData>>,
	TError = LoadSessionData400 | LoadSessionData403 | LoadSessionData500,
>(
	params?: LoadSessionDataParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof loadSessionData>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getLoadSessionDataQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Load full session data for the current user (admin can target a specific userId)
 */
export const useSetLoadSessionDataQueryData = () => {
	const queryClient = useQueryClient();
	return (
		params: LoadSessionDataParams | undefined,
		updater:
			| Awaited<ReturnType<typeof loadSessionData>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof loadSessionData>> | undefined,
			  ) => Awaited<ReturnType<typeof loadSessionData>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof loadSessionData>>>(
			{ queryKey: getLoadSessionDataQueryKey(params) },
			updater,
		);
	};
};

/**
 * @summary Load full session data for the current user (admin can target a specific userId)
 */
export const useGetLoadSessionDataQueryData = () => {
	const queryClient = useQueryClient();
	return (params?: LoadSessionDataParams) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof loadSessionData>>>(
			getLoadSessionDataQueryKey(params),
		);
};

export const getPollForUpdatesUrl = () => {
	return `/session/poll-for-updates`;
};

/**
 * @summary Poll for recently updated devices and recent sensor data for the current user
 */
export const pollForUpdates = async (
	pollForUpdatesBody?: PollForUpdatesBody,
	options?: RequestInit,
): Promise<PollForUpdates200> => {
	return customFetch<PollForUpdates200>(getPollForUpdatesUrl(), {
		...options,
		method: "POST",
		headers: { "Content-Type": "application/json", ...options?.headers },
		body: JSON.stringify(pollForUpdatesBody),
	});
};

export const getPollForUpdatesQueryKey = (
	pollForUpdatesBody?: PollForUpdatesBody,
) => {
	return ["POST", "session", "poll-for-updates", pollForUpdatesBody] as const;
};

export const getPollForUpdatesQueryOptions = <
	TData = Awaited<ReturnType<typeof pollForUpdates>>,
	TError = PollForUpdates400 | PollForUpdates401 | PollForUpdates500,
>(
	pollForUpdatesBody?: PollForUpdatesBody,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof pollForUpdates>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getPollForUpdatesQueryKey(pollForUpdatesBody);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof pollForUpdates>>> = ({
		signal,
	}) => pollForUpdates(pollForUpdatesBody, { signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof pollForUpdates>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PollForUpdatesQueryResult = NonNullable<
	Awaited<ReturnType<typeof pollForUpdates>>
>;
export type PollForUpdatesQueryError =
	| PollForUpdates400
	| PollForUpdates401
	| PollForUpdates500;

export function usePollForUpdates<
	TData = Awaited<ReturnType<typeof pollForUpdates>>,
	TError = PollForUpdates400 | PollForUpdates401 | PollForUpdates500,
>(
	pollForUpdatesBody: undefined | PollForUpdatesBody,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof pollForUpdates>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof pollForUpdates>>,
					TError,
					Awaited<ReturnType<typeof pollForUpdates>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePollForUpdates<
	TData = Awaited<ReturnType<typeof pollForUpdates>>,
	TError = PollForUpdates400 | PollForUpdates401 | PollForUpdates500,
>(
	pollForUpdatesBody?: PollForUpdatesBody,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof pollForUpdates>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof pollForUpdates>>,
					TError,
					Awaited<ReturnType<typeof pollForUpdates>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePollForUpdates<
	TData = Awaited<ReturnType<typeof pollForUpdates>>,
	TError = PollForUpdates400 | PollForUpdates401 | PollForUpdates500,
>(
	pollForUpdatesBody?: PollForUpdatesBody,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof pollForUpdates>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Poll for recently updated devices and recent sensor data for the current user
 */

export function usePollForUpdates<
	TData = Awaited<ReturnType<typeof pollForUpdates>>,
	TError = PollForUpdates400 | PollForUpdates401 | PollForUpdates500,
>(
	pollForUpdatesBody?: PollForUpdatesBody,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof pollForUpdates>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getPollForUpdatesQueryOptions(
		pollForUpdatesBody,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Poll for recently updated devices and recent sensor data for the current user
 */
export const useSetPollForUpdatesQueryData = () => {
	const queryClient = useQueryClient();
	return (
		pollForUpdatesBody: PollForUpdatesBody | undefined,
		updater:
			| Awaited<ReturnType<typeof pollForUpdates>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof pollForUpdates>> | undefined,
			  ) => Awaited<ReturnType<typeof pollForUpdates>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof pollForUpdates>>>(
			{ queryKey: getPollForUpdatesQueryKey(pollForUpdatesBody) },
			updater,
		);
	};
};

/**
 * @summary Poll for recently updated devices and recent sensor data for the current user
 */
export const useGetPollForUpdatesQueryData = () => {
	const queryClient = useQueryClient();
	return (pollForUpdatesBody?: PollForUpdatesBody) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof pollForUpdates>>>(
			getPollForUpdatesQueryKey(pollForUpdatesBody),
		);
};
